import Popup from '../helpers/Popup';
import PopupRegister from '../helpers/PopupRegister';

;$(function() {

	var page = {};
	page.buttons = $('.popup-form');

	var action = {};
	action.showPopup = function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		let title = $(this).data('header');
		let src = $(this).data('popup') || '#popup-form';

		if (title)
			$(src).find('h2').html(title);

		action.checkAttrs(this);

		Popup.show(src, $(this));
	}
	action.checkAttrs = _ => {
		for (var i = 0; i < _.attributes.length; i++) {
			let key = _.attributes[i].nodeName;
			let val = _.attributes[i].nodeValue;

			if (key.indexOf('data-popup-') > -1)
				action.changeHiddenValue($(_).data('popup'), key.slice(11), val);
		}
	}
	action.changeHiddenValue = (target, name, value) => {
		let hidden = $(target).find('[name="' + name +'"]');
		let defaultValue = null;
		if (! hidden.length) {
			$(target).children('form').append('<input type="hidden" name="' + name +'">');
			hidden = $(target).find('[name="' + name +'"]');
		} else {
			defaultValue = hidden.val();
		}

		$(target).find('[name="' + name +'"]').val(value);

		Popup.data.src = Popup.data.src || target;
		Popup.data.defaults[name] = defaultValue;
	}

	page.buttons.click( action.showPopup );

});